import { render, staticRenderFns } from "./TifCarguesTramasImport.vue?vue&type=template&id=6d4e61d8"
import script from "./TifCarguesTramasImport.vue?vue&type=script&lang=js"
export * from "./TifCarguesTramasImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports